/* unplugin-vue-components disabled */import script from "./signin.vue?vue&type=script&setup=true&lang=js"
export * from "./signin.vue?vue&type=script&setup=true&lang=js"

import "./signin.vue?vue&type=style&index=0&id=0baed0d4&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0baed0d4"]])

export default __exports__